import React from "react";

function Showcase() {
  return (
    <div>
      <section class="text-grey-400 bg-gray-900 body-font">
        <div class="container px-5 py-24 mx-auto flex flex-wrap">
          <div class="lg:w-2/3 mx-auto">
            <div class="flex flex-wrap w-full bg-teal-800 py-32 px-10 relative mb-4">
              <img
                alt="gallery"
                class="w-full object-cover h-full object-center block absolute inset-0"
                src="./img/img2.jpg"
              />
              <div class="text-center relative z-10 w-full"></div>
            </div>
            <div class="flex flex-wrap -mx-2">
              <div class="px-2 w-1/2">
                <div class="flex flex-wrap w-full bg-gray-800 sm:py-24 py-16 sm:px-10 px-6 relative">
                  <img
                    alt="gallery"
                    class="w-full object-cover h-full object-center block opacity-50 absolute inset-0"
                    src="./img/img3.jpg"
                  />
                  <div class="text-center relative z-10 w-full">
                    <h2 class="text-xl text-white font-medium title-font mb-2">
                      Baby Foods
                    </h2>
                    <p class="leading-relaxed text-gray-500">
                      Cerelac, tooth brushes, soaps and many more.
                    </p>
                  </div>
                </div>
              </div>
              <div class="px-2 w-1/2">
                <div class="flex flex-wrap w-full bg-gray-800 sm:py-24 py-16 sm:px-10 px-6 relative">
                  <img
                    alt="gallery"
                    class="w-full object-cover h-full object-center block opacity-50 absolute inset-0"
                    src="./img/img2.jpg"
                  />
                  <div class="text-center relative z-10 w-full">
                    <h2 class="text-xl text-white font-medium title-font mb-2">
                      Spices
                    </h2>
                    <p class="leading-relaxed text-gray-500">
                      All popular brand spices, packed foods, tea.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Showcase;
